import { render, staticRenderFns } from "./attributes-editor-modal.vue?vue&type=template&id=4ff39949"
import script from "./attributes-editor-modal.vue?vue&type=script&lang=js"
export * from "./attributes-editor-modal.vue?vue&type=script&lang=js"
import style0 from "./attributes-editor-modal.vue?vue&type=style&index=0&id=4ff39949&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports